<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 ms-3 overflow-visible me-3 pt-3">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Event</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'eventId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="((field.name !== 'eventId') || (field.name === 'eventId' && editMode)) && (field.name !== 'status') && (field.name !== 'active') && (field.name !== 'application')"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'eventId') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Event' }}</a>
            <a role="button" class="ms-3 procricket-btn--reverse " @click="cancelEdit"> Cancel </a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {Event} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'EventEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        eventId : this.$route.params.eventId,
        firstMatcher : this.$route.params.firstMatcher,
        secondMatcher : this.$route.params.secondMatcher,
        league : this.$route.params.league,
        leagueId : this.$route.params.leagueId,
        orderNumber : this.$route.params.orderNumber,
        application : this.$route.params.application,
        status : this.$route.params.status,
        active : this.$route.params.active
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "eventId", label: "Event Id" },
        { name: "firstMatcher", label: "First Matcher" },
        { name: "secondMatcher", label: "Second Matcher" },
        { name: "league", label: "League" },
        { name: "leagueId", label: "League Id" },
        { name: "orderNumber", label: "Order Number" },
        { name: "application", label: "Application" },
        { name: "status", label: "Status" },
        { name: "active", label: "Active" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.eventId) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new Event(
          this.editedConfig.eventId ,
          this.editedConfig.firstMatcher ,
          this.editedConfig.secondMatcher ,
          this.editedConfig.league ,
          this.editedConfig.leagueId ,
          this.editedConfig.orderNumber,
          this.editedConfig.application,
          this.editedConfig.status,
          this.editedConfig.active
      );

      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateEvent(dataToSave).then(() => {
          alert('Insert complete');

          // Redirect to the /stripe page
          this.$router.push({ name: 'Events' });
        }).catch((error) => {
          console.error("Error updating Events:", error);
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertEvent(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the /stripe page
          this.$router.push({ name: 'Events' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    },
    cancelEdit() {
      this.$router.back();
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
